import { useState } from 'react';
import Riesgo1 from './Riesgo1';
import Riesgo2 from './Riesgo2';
import Riesgo3 from './Riesgo3';
import Riesgo4 from './Riesgo4';

const EvaluacionRiesgoMain = ({ onClose, onResultadosListos }) => {
  const [pagina, setPagina] = useState(1);
  
  const [formData, setFormData] = useState({
    extension: null,
    caracteristica: null,
    impactoSGSS: null,
    impactoSocial: null,
    extensionGeografica: null,
    caracteristicasEvento: null,
    vigilancia: null,
    medios: null,
  });

  function calcularResultados(data) {
  // Sumar los valores (asumiendo que son numéricos)
  const total =
    (Number(data.extension) || 0) +
    (Number(data.caracteristica) || 0) +
    (Number(data.impactoSGSS) || 0) +
    (Number(data.impactoSocial) || 0) +
    (Number(data.extensionGeografica) || 0) +
    (Number(data.caracteristicasEvento) || 0) +
    (Number(data.vigilancia) || 0) +
    (Number(data.medios) || 0);

  let nivel = '';
  let respuesta = '';

  if (total < 25) {
    nivel = 'I';
    respuesta = 'Respuesta Municipal';
  } else if (total <= 80) {
    nivel = 'II';
    respuesta = 'Respuesta Departamental';
  } else if (total <= 120) {
    nivel = 'III';
    respuesta = 'Respuesta Departamental/Nacional';
  } else {
    nivel = 'IV';
    respuesta = 'Respuesta Nacional/Intersectorial/Internacional';
  }

  return {
    evaluacion: total.toString(),
    nivel,
    respuesta,
  };

}

  const handleSiguiente = () => {
    setPagina((prev) => Math.min(prev + 1, 4));
  };

  const handleAnterior = () => {
    setPagina((prev) => Math.max(prev - 1, 1));
  };

  const handleCerrar = () => {
    setPagina(0);
    if (onClose) onClose();
  };

  const handleFinalizar = (dataFinal) => {
  setFormData(dataFinal);
  const resultados = calcularResultados(dataFinal);
  if (onResultadosListos) onResultadosListos(resultados);
  handleCerrar();
};

  return (
    <>
      {pagina === 1 && (
        <Riesgo1
          siguiente={handleSiguiente}
          onClose={handleCerrar}
          formData={formData}
          setFormData={setFormData}
        />
      )}
      {pagina === 2 && (
        <Riesgo2
          siguiente={handleSiguiente}
          anterior={handleAnterior}
          onClose={handleCerrar}
          formData={formData}
          setFormData={setFormData}
        />
      )}
      {pagina === 3 && (
        <Riesgo3
          siguiente={handleSiguiente}
          anterior={handleAnterior}
          onClose={handleCerrar}
          formData={formData}
          setFormData={setFormData}
        />
      )}
      {pagina === 4 && (
        <Riesgo4
          anterior={handleAnterior}
          onClose={handleCerrar}
          formData={formData}
          setFormData={setFormData}
          finalizar={handleFinalizar} // <-- se pasa la función final aquí
        />
      )}
    </>
  );
};

export default EvaluacionRiesgoMain;
